import React, { useEffect, useState } from "react";
import { View } from "react-native";
import ThemeProvider from "@voltmoney/theme";
import { Typography } from "../../../typography/Typography";
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, IconSizeTokens, IconTokens, SizeTypeTokens, TypographyTypeDLS } from "@voltmoney/schema";
import TextInputDLS from "../../../textInputDLS/textInputDLS";
import { Space } from "../../../space/Space";
import { DropdownInput } from "../../../dropDownInput/DropDownBaseInput";
import { TermsText } from "../../../termsText/TermsText";
import { Button } from "../../../button/Button";
import { Icon } from "../../../icon/Icon";
import { isPanValid, isPhoneNumberValid } from "../../../pages/utils";
import { TextInputStateDLS } from "@voltmoney/schema/lib/textInputDLS";
import { dateFormatDropDown, dateFormatForBE, formatDateToText, generateDropDownData, getCurrentDate } from "./utils";
import AsyncStorage from "@react-native-async-storage/async-storage";
const CgtcInitPage = ({ show = true, getStatementAction, triggerAction, cgtcUserData, fyData, termsLink, privacyLink, amplitudeEventPanAction, amplitudeEventPhoneAction, amplitudeEventTandCAction, amplitudeEventFinancialYearAction, amplitudeEventPrivacyAction, }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    // const cgtcUserData = await AsyncStorage.getItem('cgtc');
    const [_cgtcUserData, setCgtcUserData] = useState(undefined);
    const [pan, setPan] = useState(_cgtcUserData?.pan ? _cgtcUserData?.pan : '');
    const [panState, setPanState] = useState(TextInputStateDLS.DEFAULT);
    const [phone, setPhone] = useState(_cgtcUserData?.phone ? _cgtcUserData?.phone : '');
    const [phoneState, setPhoneState] = useState(TextInputStateDLS.DEFAULT);
    const [fy, setFy] = useState((_cgtcUserData?.toDate && _cgtcUserData?.fromDate)
        ? JSON.stringify({
            fromDate: dateFormatDropDown(_cgtcUserData?.fromDate),
            toDate: dateFormatDropDown(_cgtcUserData?.toDate)
        })
        : '');
    const [btnActive, setBtnActive] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [toDate, setToDate] = useState(undefined);
    const [fromDate, setFromDate] = useState(undefined);
    const [dropDownData, setDropDownData] = useState(generateDropDownData(fyData));
    useEffect(() => {
        console.log('toDate', toDate);
        console.log('fromDate', fromDate);
    }, [
        toDate,
        fromDate
    ]);
    const setUserContext = async () => {
        setCgtcUserData(JSON.parse(await AsyncStorage.getItem('cgtc')));
    };
    useEffect(() => {
        console.log('cgtcUserData: ', _cgtcUserData);
        setPan(_cgtcUserData?.pan);
        setPhone(_cgtcUserData?.phone);
        setFy((_cgtcUserData?.toDate && _cgtcUserData?.fromDate)
            ? JSON.stringify({
                fromDate: dateFormatDropDown(_cgtcUserData?.fromDate),
                toDate: dateFormatDropDown(_cgtcUserData?.toDate)
            })
            : '');
    }, [_cgtcUserData]);
    useEffect(() => {
        setUserContext();
    }, []);
    useEffect(() => {
        if (isPanValid(pan) &&
            isPhoneNumberValid(phone) &&
            fy) {
            setBtnActive(true);
        }
    }, []);
    useEffect(() => {
        console.log('pan: ', pan);
        console.log('phone: ', phone);
        console.log('fy: ', fy && JSON.parse(fy));
        console.log('pan: ', isPanValid(pan));
        console.log('phone: ', isPhoneNumberValid(phone));
        if (isPanValid(pan) &&
            isPhoneNumberValid(phone) &&
            fy) {
            setBtnActive(true);
            setPanState(TextInputStateDLS.DEFAULT);
            setPhoneState(TextInputStateDLS.DEFAULT);
        }
        else {
            setBtnActive(false);
            console.warn("PAN INPUT RECEIEVED");
            //Handle PAN case
            if (pan && pan !== ''
                && !isPanValid(pan)) {
                setPanState(TextInputStateDLS.ERROR);
            }
            else {
                amplitudeEventPanAction &&
                    triggerAction(amplitudeEventPanAction);
                setPanState(TextInputStateDLS.DEFAULT);
            }
            //Handle Phone case
            if (phone && phone !== '' &&
                !isPhoneNumberValid(phone)) {
                setPhoneState(TextInputStateDLS.ERROR);
            }
            else {
                amplitudeEventPhoneAction &&
                    triggerAction(amplitudeEventPhoneAction);
                setPhoneState(TextInputStateDLS.DEFAULT);
            }
        }
        if (fy) {
            const fyData = JSON.parse(fy);
            setToDate((fyData.toDate || fyData.toDate !== '') ?
                fyData?.toDate : getCurrentDate());
            setFromDate((fyData.fromDate || fyData.fromDate !== '') ?
                fyData?.fromDate : getCurrentDate());
            amplitudeEventFinancialYearAction &&
                triggerAction(amplitudeEventFinancialYearAction);
        }
    }, [
        pan,
        phone,
        fy
    ]);
    useEffect(() => {
        console.log('fyData: ', fyData);
    }, [
        fyData
    ]);
    return (React.createElement(View, { style: [
            styles.container,
            {
                width: '100%',
                backgroundColor: colorMapping[ColorTokens.White]
            }
        ] },
        React.createElement(View, { style: [
                styles.header,
                { backgroundColor: colorMapping[ColorTokens.Secondary_10] }
            ] },
            React.createElement(Typography, { label: 'Calculate capital gains on mutual funds in 30 sec!', typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night })),
        React.createElement(View, { style: styles.body },
            React.createElement(View, null,
                React.createElement(TextInputDLS, { label: 'Enter PAN', holder: 'Enter PAN', autoFocus: false, inputState: panState, helperText: 'Please enter a valid pan number', value: pan, isFromCgs: true, onChangeText: (value) => {
                        if (value.length >= 11) {
                            return;
                        }
                        setPan(value.trim().toUpperCase());
                    } }),
                panState !== TextInputStateDLS.ERROR &&
                    React.createElement(View, { style: {
                            paddingTop: 4,
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center'
                        } },
                        React.createElement(Icon, { name: IconTokens.SecureIcon, size: IconSizeTokens.XXL }),
                        React.createElement(Space, { size: SizeTypeTokens.SM }),
                        React.createElement(Typography, { label: 'We need PAN to generate capital gain statement.', typeDLS: TypographyTypeDLS.B3R, color: ColorTokens.Grey_Charcoal }))),
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            React.createElement(View, null,
                React.createElement(TextInputDLS, { holder: 'Enter mobile number', label: 'Enter mobile number', autoFocus: false, isFromCgs: true, value: phone, inputState: phoneState, helperText: 'Please enter a valid phone number', onChangeText: (value) => {
                        if (value.length >= 11) {
                            return;
                        }
                        if (isNaN(Number(value))) {
                            return;
                        }
                        else {
                            setPhone(value.trim());
                        }
                    } })),
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            React.createElement(View, null,
                React.createElement(DropdownInput, { data: dropDownData, label: 'Select financial year', value: JSON.stringify({
                        fromDate: dateFormatDropDown(_cgtcUserData?.fromDate),
                        toDate: dateFormatDropDown(_cgtcUserData?.toDate, true)
                    }), onValueSelect: (val) => {
                        setFy(val);
                    } }),
                fromDate &&
                    toDate &&
                    React.createElement(View, { style: {
                            paddingTop: 4
                        } },
                        React.createElement(Typography, { label: `Date range: ${formatDateToText(fromDate)} - ${formatDateToText(toDate)}`, typeDLS: TypographyTypeDLS.B3R, color: ColorTokens.Grey_Night }))),
            React.createElement(Space, { size: SizeTypeTokens.Size32 }),
            React.createElement(View, null,
                React.createElement(TermsText, { termsUrl: termsLink, privayUrl: privacyLink, onPressTerms: () => {
                        amplitudeEventTandCAction &&
                            triggerAction(amplitudeEventTandCAction);
                    }, onPressPrivacy: () => {
                        amplitudeEventPrivacyAction &&
                            triggerAction(amplitudeEventPrivacyAction);
                    } })),
            React.createElement(Space, { size: SizeTypeTokens.SIZE14 }),
            React.createElement(View, { style: { marginTop: 2 } }),
            React.createElement(View, { style: {
                    width: '100%'
                } },
                React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, isDisabled: !btnActive, sizeDLS: ButtonSizeDLS.LARGE, label: 'Get statement', loading: btnLoading, onPress: async () => {
                        setBtnLoading(true);
                        getStatementAction &&
                            await triggerAction({
                                ...getStatementAction,
                                payload: {
                                    ...getStatementAction.payload,
                                    phone: phone,
                                    pan: pan,
                                    fromDate: dateFormatForBE(fromDate),
                                    toDate: dateFormatForBE(toDate)
                                }
                            });
                        setBtnLoading(false);
                    } })),
            React.createElement(Space, { size: SizeTypeTokens.MD }),
            React.createElement(View, { style: {
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                } },
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center'
                    } },
                    React.createElement(Icon, { name: IconTokens.SecureIcon, size: IconSizeTokens.XXL }),
                    React.createElement(Space, { size: SizeTypeTokens.SM }),
                    React.createElement(Typography, { label: 'Powered by MFCentral', typeDLS: TypographyTypeDLS.B3R, color: ColorTokens.Grey_Night }))),
            React.createElement(Space, { size: SizeTypeTokens.Size32 }),
            React.createElement(View, { style: {
                    backgroundColor: '#FEF4E6',
                    paddingHorizontal: 12,
                    paddingVertical: 8,
                    display: 'flex',
                    flexDirection: 'row',
                    borderRadius: 8
                } },
                React.createElement(View, { style: {
                        width: 24,
                        height: 24,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    } },
                    React.createElement(Icon, { name: IconTokens.SYSTEM_INFO_DLS, color: ColorTokens.Warning_100, size: IconSizeTokens.XXL })),
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                React.createElement(Typography, { label: 'Currently, capital gains are available for investments with individual ownership. Support for joint or anyone survivor ownership is coming soon!', typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Night })))));
};
const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    header: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16
    },
    body: {
        width: '100%',
        maxWidth: 412,
        paddingBottom: 24,
        paddingTop: 32,
        paddingLeft: 16,
        paddingRight: 16
    }
};
export default CgtcInitPage;
